import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { planName, PlanType } from '@lib/billing-plan-name';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $orgInfoSubscriptionType } from '@nx-frontend/shared/store/org-info';
import { $orgUsageData } from '@nx-frontend/shared/store/org-usage';
import { OrgInfoSubscriptionType } from '@nx-frontend/shared/types';
import { $draftInviteCount } from '../store';

export const ClientsLimitMessage = () => {
  const t = useTranslations('features');
  const [subscriptionType, orgUsage, draftInviteCount] = useUnit([
    $orgInfoSubscriptionType,
    $orgUsageData,
    $draftInviteCount,
  ]);

  const clientsCurrent = orgUsage.clients.current + draftInviteCount.client;

  const upgradeSubscriptionTypeName = useMemo(() => {
    if (subscriptionType === OrgInfoSubscriptionType.PLUS || subscriptionType === OrgInfoSubscriptionType.PLUS2024) {
      if (clientsCurrent > 15) {
        return planName[PlanType.BUSINESS];
      } else {
        return planName[PlanType.TEAM];
      }
    } else if (
      subscriptionType === OrgInfoSubscriptionType.TEAM ||
      subscriptionType === OrgInfoSubscriptionType.TEAM2024
    ) {
      return planName[PlanType.BUSINESS];
    }
    return 'Unknown';
  }, [clientsCurrent, subscriptionType]);

  return (
    <div className="flex items-center justify-center w-full px-4 py-2.5">
      <div className="mr-2">
        <Icon icon={IconsMap.INFO} className="w-5 h-5 text-red-500" />
      </div>
      <p className="font-inter text-sm text-left">
        {t('manage-members.auto_upgrade_message', { subscriptionType: upgradeSubscriptionTypeName })}
      </p>
    </div>
  );
};
